exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link {\n  font-weight: bold;\n  color: #90CC1B;\n}\n.link:hover {\n  color: #73a314;\n}", ""]);

// exports
